import { InputType } from './input-type';

export default InputType;
